import { get, pickBy, isEmpty, map, find, head, filter, compact } from 'lodash'
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { v4 as uuid } from 'uuid'
import Fuse from 'fuse.js'

import Autocomplete from 'components/Autocomplete'

import ItemsEdit from 'containers/ItemsEdit'
import Textbox from 'components/Textbox'
import DropdownSelect from 'components/DropdownSelect'
import CheckboxGroup from 'components/CheckboxGroup'

import { getConfigurationWithResources } from 'store/Configurations/selector'
import { getCurrentVenueId } from 'store/Venues/selector'
import { getRevenues } from 'store/Revenues/selector'
import { getSelectablePrinters, getPrinters } from 'store/Printers/selector'
import { deleteConfiguration } from 'store/Configurations/actions'
import { ORG_NAME } from 'utils/env'
import { shapeConfigurationItem } from 'resources/typeDefs'
import { formattedAutocompleteList } from 'utils/configurations'
import { SELECTABLE_SUBTYPES, FUSE_OPTIONS } from 'utils/constants'
import DialogModal from 'components/DialogModal'
export class ConfigurationsForm extends Component {
  static propTypes = {
    editedItem: shapeConfigurationItem,
    selectablePrinters: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }),
    ).isRequired,
    deleteConfiguration: PropTypes.func.isRequired,
    title: PropTypes.string,
    venueUuid: PropTypes.string.isRequired,
    callApi: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
    // eslint-disable-next-line
    revenueCenters: PropTypes.array,
  }

  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      name: props?.editedItem?.name ?? '',
      deviceId: props?.editedItem?.deviceId ?? '',
      receiptPrinterUuid: props?.editedItem?.configuration?.receiptPrinterUuid ?? '',
      deviceSubtype: props?.editedItem?.deviceSubtype ?? SELECTABLE_SUBTYPES[0].value,
      revenueCenters: props?.revenueCenters ?? [],
      selectedMultiMenu: props?.editedItem?.selectedRevenue ?? [],
      esKey: props?.editedItem?.configuration?.esKey ?? '',
      storeId: props?.editedItem?.configuration?.storeId ?? '',
      terminalId: props?.editedItem?.configuration?.terminalId ?? '',
      selectedMenu: props?.editedItem?.selectedMenus ?? [],
      selectedXpediteRevenue: props?.editedItem?.selectedXpediteRevenueCenter ?? [],
      selectedRevenue: props?.editedItem?.selectedSingleRevenue ?? {},
      uatUrl: props?.editedItem?.configuration?.uatUrl ?? '',
      prodUrl: props?.editedItem?.configuration?.prodUrl ?? '',
      host: props?.editedItem?.configuration?.host ?? '',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deviceSubtype !== this.state.deviceSubtype) {
      this.setState({
        selectedMenu: [],
        selectedRevenue: [{ label: '', value: '' }],
        selectedXpediteRevenue: [{ label: '', value: '' }],
      })
    }
  }

  resourceId = () => this.props.match.params.id

  redirectToConfigurations = () => {
    this.props.history.push(`/configurations`)
  }

  handleChange = (event) => {
    const { name, value } = event.target
    this.setState({
      [name]: value,
    })
  }

  handleAutocompleteInputChange = (e) => {
    this.setState({
      [e.target.name]: [
        {
          label: e.target.value,
        },
      ],
    })
  }

  handleRevenueChange = (name, val) => {
    this.setState({
      [name]: val,
      selectedMenu: [
        {
          label: '',
          value: '',
        },
      ],
    })
  }

  handleAutocompleteDropdownChange = (name, val) => {
    this.setState({
      [name]: val,
    })
  }

  handleCheckboxChange = (checked, event) => {
    const checkbox = {
      label: event.target.labels[0].outerText,
      value: event.target.name,
    }
    this.setState((prevState) => {
      return checked
        ? {
            selectedMenu: [...prevState.selectedMenu, checkbox],
          }
        : {
            selectedMenu: prevState.selectedMenu.filter((menu) => menu.value !== event.target.name),
          }
    })
  }

  renderSubtypeSubselect = (revenueCenter) => {
    const { selectedMenu } = this.state
    const menus = revenueCenter.menus.filter((menu) => menu.serviceType === 'POS')
    const menusOptions = isEmpty(selectedMenu[0].label)
      ? formattedAutocompleteList(menus, 'Unamed menu')
      : new Fuse(formattedAutocompleteList(menus, 'Unamed menu'), FUSE_OPTIONS).search(
          selectedMenu[0].label,
        )

    return (
      <>
        <Autocomplete
          handleAutocompleteDropdownChange={this.handleAutocompleteDropdownChange}
          handleAutocompleteInputChange={this.handleAutocompleteInputChange}
          isRequired={true}
          label="Menu"
          name="selectedMenu"
          options={menusOptions}
          selectedOption={head(selectedMenu)}
        />
      </>
    )
  }

  renderSubtypeSelect = () => {
    const { deviceSubtype, selectedMenu, selectedRevenue, selectedXpediteRevenue, revenueCenters } =
      this.state
    const selectedMenusInCheckboxes = map(selectedMenu, (menu) => menu.value)

    const revenueCentersIncludesMenuServiceTypePOS = filter(revenueCenters, (revenueCenter) =>
      revenueCenter.menus.some((menu) => menu.serviceType === 'POS'),
    )

    const revenueCentersIncludesMenuServiceTypeKiosk = filter(revenueCenters, (revenueCenter) =>
      revenueCenter.menus.some((menu) => menu.serviceType === 'Kiosk'),
    )

    const revenuesOptions = isEmpty(selectedRevenue[0].label)
      ? formattedAutocompleteList(revenueCentersIncludesMenuServiceTypePOS, 'Unamed revenue')
      : new Fuse(
          formattedAutocompleteList(revenueCentersIncludesMenuServiceTypePOS, 'Unamed revenue'),
          FUSE_OPTIONS,
        ).search(selectedRevenue[0].label)

    const isAnyCheckboxSelected = isEmpty(selectedMenu)

    if (deviceSubtype === 'suites-pos') {
      return null
    } else if (deviceSubtype === 'kiosk') {
      return (
        <CheckboxGroup
          handleChange={this.handleCheckboxChange}
          header="Revenue center"
          isRequired={isAnyCheckboxSelected}
          items={revenueCentersIncludesMenuServiceTypeKiosk}
          menuFilterQuery="Kiosk"
          selectedItems={selectedMenusInCheckboxes}
        />
      )
    } else {
      const isXpedite = deviceSubtype === 'xpedite'

      if (isXpedite) {
        return (
          <Autocomplete
            handleAutocompleteDropdownChange={this.handleRevenueChange}
            handleAutocompleteInputChange={this.handleAutocompleteInputChange}
            isRequired={true}
            label="Revenue center"
            name="selectedXpediteRevenue"
            options={formattedAutocompleteList(revenueCenters)}
            selectedOption={head(selectedXpediteRevenue)}
          />
        )
      } else {
        return (
          <>
            <Autocomplete
              handleAutocompleteDropdownChange={this.handleRevenueChange}
              handleAutocompleteInputChange={this.handleAutocompleteInputChange}
              isRequired={true}
              label="Revenue center"
              name="selectedRevenue"
              options={revenuesOptions}
              selectedOption={head(selectedRevenue)}
            />
            {!isEmpty(selectedRevenue[0].label) &&
              !isEmpty(selectedRevenue[0].value) &&
              this.renderSubtypeSubselect(find(revenueCenters, ['uuid', selectedRevenue[0].value]))}
          </>
        )
      }
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const {
      name,
      deviceId,
      printerId,
      deviceSubtype,
      esKey,
      storeId,
      terminalId,
      selectedMenu,
      selectedXpediteRevenue,
      receiptPrinterUuid,
      uatUrl,
      prodUrl,
      host,
    } = this.state

    const { editedItem } = this.props

    const { callApi, venueUuid } = this.props

    const configuration = {
      menuUuids: compact(selectedMenu.map((menu) => menu.value)),
      standUuids:
        selectedXpediteRevenue?.map((selectedXpediteRevenue) => selectedXpediteRevenue.value) ?? [],
      controlledPrinterUuids: editedItem?.configuration?.controlledPrinterUuids ?? '',
      esKey,
      storeId,
      terminalId,
      receiptPrinterUuid,
      uatUrl,
      prodUrl,
      host,
    }

    const formatedconfiguration = pickBy(configuration, (value, _key) => !isEmpty(value))

    const data = {
      configuration: formatedconfiguration,
      name,
      deviceId,
      printerId,
      deviceSubtype,
      uuid: this.resourceId() || uuid(),
      organizationName: ORG_NAME,
      venueUuid,
    }

    const formatedData = pickBy(data, (value, _key) => !isEmpty(value))

    callApi({ appDeviceConfigurations: [formatedData] }).then(() => {
      if (this.resourceId()) {
        toast.success('Configuration successfully updated')
      } else {
        toast.success('Configuration successfully created')
      }
      this.redirectToConfigurations()
    })
  }

  handleDeleteConfiguration = () => {
    const { deleteConfiguration } = this.props
    this.toggleModal()

    if (this.resourceId()) {
      deleteConfiguration(this.resourceId()).then(() => {
        toast.success('Configuration successfully deleted')
        this.redirectToConfigurations()
      })
    }
  }

  toggleModal = () =>
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }))

  render() {
    const {
      isModalOpen,
      receiptPrinterUuid,
      deviceSubtype,
      esKey,
      storeId,
      terminalId,
      name,
      deviceId,
      uatUrl,
      prodUrl,
      host,
    } = this.state

    const { title, selectablePrinters } = this.props

    const noPrinterOption = !isEmpty(receiptPrinterUuid) ? { label: 'No printer', value: '' } : null

    const receiptPrintersOptions = compact([
      ...filter(selectablePrinters, (printer) => !isEmpty(printer.value)),
      noPrinterOption,
    ])

    const modalBody = <div className="dialog-modal__body-text">Do you want to continue?</div>

    return (
      <ItemsEdit onClose={this.redirectToConfigurations} title={title}>
        <form onSubmit={this.handleSubmit}>
          <section className="form__fieldset">
            <Textbox
              label="Name"
              min={0}
              name="name"
              onChange={this.handleChange}
              required
              value={name}
            />
            <DropdownSelect
              className="-block"
              fullWidth
              isValid
              label="Mode"
              name="deviceSubtype"
              onChange={this.handleChange}
              options={SELECTABLE_SUBTYPES}
              required
              value={deviceSubtype}
            />
            {this.renderSubtypeSelect()}
            <DropdownSelect
              className="-block"
              fullWidth
              isEmptyOption
              isValid
              label="Receipt Printer Name"
              name="receiptPrinterUuid"
              onChange={this.handleChange}
              options={receiptPrintersOptions}
              value={receiptPrinterUuid}
            />
            <div className="form__header">Shift4</div>
            <Textbox
              label="Host IP (if applicable)"
              min={0}
              name="host"
              onChange={this.handleChange}
              value={host}
            />
            <div className="form__header">Card Reader Settings</div>
            <Textbox
              label="Token / Key"
              min={0}
              name="esKey"
              onChange={this.handleChange}
              value={esKey}
            />
            <Textbox
              label="Store ID (if applicable)"
              min={0}
              name="storeId"
              onChange={this.handleChange}
              value={storeId}
            />
            <Textbox
              label="Terminal ID (if applicable)"
              name="terminalId"
              onChange={this.handleChange}
              value={terminalId}
            />
            <Textbox
              label="Production URL"
              name="prodUrl"
              onChange={this.handleChange}
              value={prodUrl}
            />
            <Textbox label="UAT URL" name="uatUrl" onChange={this.handleChange} value={uatUrl} />
          </section>
          <section className="form__buttons">
            <button
              className="btn -lg -primary -block margin-bottom-base"
              onClick={() => {}}
              type="submit"
            >
              Save
            </button>
            {this.resourceId() && isEmpty(deviceId) && (
              <button className="btn -lg -outline -block" onClick={this.toggleModal} type="button">
                Delete Configuration
              </button>
            )}
          </section>
        </form>
        <DialogModal
          closeModalCallback={this.toggleModal}
          confirmationCallback={this.handleDeleteConfiguration}
          modalBody={modalBody}
          modalButtonText="OK"
          modalIsOpen={isModalOpen}
        />
      </ItemsEdit>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  revenueCenters: getRevenues(state),
  editedItem: getConfigurationWithResources(state, get(ownProps, ['match', 'params', 'id'])),
  venueUuid: getCurrentVenueId(state),
  selectablePrinters: getSelectablePrinters(state, get(ownProps, ['match', 'params', 'id'])),
  printers: getPrinters(state),
})

const mapDispatchToProps = {
  deleteConfiguration,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ConfigurationsForm)
